import React from 'react';

import { translate } from 'sharedreact/utils/LanguageSupport';

type Props = {
  id: string,
  language: string,
  icon?: string,
  title: string,
  description: string,
  appId: string,
  launchUrl?: string
};

class LaunchCard extends React.Component<Props> {
  renderMultilineText (text: string) {
    let lines = [];
    const separatedText: string[] = text.split('\n');

    lines.push(<span key={0}>{separatedText[0]}</span>);

    for (let lineIndex = 1; lineIndex < separatedText.length; lineIndex++) {
      lines.push(<br key={lineIndex * 2 - 1} />);
      lines.push(<span key={lineIndex * 2}>{separatedText[lineIndex]}</span>);
    }

    return lines;
  }

  doLaunch (url: string) {
    window.location.href = url;
  }

  override render (): React.ReactNode {
    const { id, icon, title, description, appId,
      launchUrl } = this.props;

    return (
      <div className='webappslauncher-download-card webappslauncher-launch-card'
        onClick={() => {
          if (launchUrl != null){
            this.doLaunch(launchUrl);
          }
        }}>
        <div>
          {icon != null
          ? <img src={icon} alt='' className='webappslauncher-download-icon-size' />
          : <div className='webappslauncher-download-icon-size' />
          }
        </div>
        <div className='webappslauncher-download-title-description'>
          <a id={id}
            href={launchUrl}
            title={translate('launcher.home.tooltip.' + appId)}>
            <h3>{title}</h3>
          </a>
          <div className='webappslauncher-download-description'>{this.renderMultilineText(description)}</div>
        </div>
      </div>
    );
  }
}

export default LaunchCard;
